import { useHistoryWithReferrer } from '@utils/history';
import { packAndTrack } from '@v2/services/analytics.service';

import styles from '@styles/buttons';

type TButtonType = 'BLUE' | 'RED' | 'SECONDARY' | 'LINK' ;

export function CTAButton(
    { text, url, style, width, ctaEventName, ctaEventPage }
    : { text?: string, style?: TButtonType, width?: string,
        url: string, ctaEventName?: string, ctaEventPage?: string }
) {
    const history = useHistoryWithReferrer();

    return (
        <button
        tabIndex={0}
        className={`${styles} button ${style ? style.toLowerCase() : 'blue'}`}
        style={{'width': `${width ? width : '200'}px`}}
        onClick={() => {
            history.pushWithReferrer(url)
            if (ctaEventName && ctaEventPage) {
                packAndTrack(ctaEventName, [{ 'view': ctaEventPage, 'section': 'Custom' }]);
            }
        }}>
        {text ? text : 'Text Here'}
      </button>
    );
}